// Keeps the "#" row-number column pinned to the left edge while the rest of
// a wide table scrolls horizontally, so the user never loses track of which
// row they're looking at. `isStripedRow` should match the same odd/row
// index logic used by the table's `striped` variant so the sticky cell's
// own background doesn't mismatch the row it belongs to.
//
// The box-shadow carries a solid 1px strip in the cell's own background
// color, abutting its right edge, before a hard separator line. Sticky
// positioning combined with border-collapse:separate is prone to a
// sub-pixel rounding gap at that edge, letting scrolled-under content peek
// through by ~1px; the solid strip papers over that gap instead of relying
// on the cell's real width to butt up perfectly against the next column.
// Both layers use 0 blur - a blurred shadow extends vertically past the
// cell's own edges too (even with a 0 vertical offset) and can escape the
// table container's rounded corner where a sticky cell meets it, showing
// up as a stray sliver above the header row.
export const stickyColShadow = (bgColor) =>
    `1px 0 0 0 ${bgColor}, 3px 0 0 0 rgba(15, 54, 80, 0.12)`;

// width:"1px" + whiteSpace:"nowrap" is the standard table trick to force a
// column to shrink to its content's minimum width instead of stretching -
// the browser can't go narrower than the "#" content, but won't go wider
// either, unlike an unconstrained column which stretches to share leftover
// table width.
export const stickyColHeaderProps = {
    position: "sticky",
    left: 0,
    zIndex: 2,
    bg: "white",
    boxShadow: stickyColShadow("white"),
    width: "1px",
    whiteSpace: "nowrap",
};

export const stickyColCellProps = (isStripedRow) => ({
    position: "sticky",
    left: 0,
    zIndex: 1,
    bg: isStripedRow ? "surface.100" : "white",
    boxShadow: stickyColShadow(isStripedRow ? "#F4F7FB" : "white"),
    width: "1px",
    whiteSpace: "nowrap",
});
